// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-totals[data-v-5993259b]{display:grid;grid-template-columns:1fr auto;gap:12px;padding:20px;margin:0}.payment-totals dd[data-v-5993259b]{margin:0;font-weight:600}", ""]);
// Exports
module.exports = exports;
